import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Highlighted from 'components/Highlighted'

import { gray, white } from 'styles/colors'
import { title, body, header5 } from 'styles/texts'
import {
  isSelfSelector,
  isAdminSelector,
  queryStringSelector,
  experienceInfoSelector,
} from 'selectors'

import TagListComponent from 'components/TagList'
import EditModalButton from 'components/EditModalButton'
import EditExperience from 'components/EditExperience'

const Wrapper = styled.div`
  margin-top: 8px;
  padding: 30px;
  background-color: ${white};
  border-radius: 6px;
  position: relative;
`

const Logo = styled.img`
  position: absolute;
  right: 30px;
  top: 30px;
  display: block;
  height: 60px;
  width: 100px;
  object-fit: contain;
  object-position: right top;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2px;
  margin-right: 110px;
`

const Type = styled.img`
  margin-right: 8px;
`

const Title = styled.div`
  ${title};
`

const Duration = styled.div`
  ${body};
  color: ${gray};
`

const Subtitle = styled.div`
  ${body};
  color: ${gray};
`

const Heading = styled.div`
  ${header5};
  margin-top: 20px;
`

const Body = styled(Highlighted)`
  ${body};
  overflow-wrap: break-word;
`

const TagList = styled(TagListComponent)`
  margin-top: 20px;
`

const Project = ({
  className,
  type,
  logo,
  title,
  duration,
  subtitle,
  heading,
  text,
  tags,
  isSelf,
  isAdmin,
  consultantId,
  experienceId,
  queryString,
}) => (
  <Wrapper className={className}>
    <Header>
      <Type src={`/icons/${type}.svg`} alt="" />
      <Title>{title}</Title>
      {(isSelf || isAdmin) && (
        <EditModalButton
          title="Endre erfaring"
          renderForm={props => (
            <EditExperience
              {...props}
              consultantId={consultantId}
              experienceId={experienceId}
            />
          )}
        />
      )}
    </Header>
    <Logo src={`/logos/${logo}`} alt="" />
    <Duration>{duration}</Duration>
    <Subtitle>{subtitle}</Subtitle>
    <Heading>{heading}</Heading>
    <Body>{text}</Body>
    {tags && <TagList tags={tags} />}
  </Wrapper>
)

const mapStateToProps = (state, { consultantId, experienceId }) => ({
  isSelf: isSelfSelector(state, consultantId),
  isAdmin: isAdminSelector(state),
  queryString: queryStringSelector(state),
  ...(experienceInfoSelector(state, consultantId, experienceId) || {}),
})

export default connect(mapStateToProps)(Project)



// WEBPACK FOOTER //
// ./src/components/Consultant/Experience/Project.js